import axios from 'axios';

export default (id, rooms) =>
  axios.patch(`${process.env.VUE_APP_API_ENDPOINT}/buildings/${id}/rooms`, {
    rooms,
  });
